import React ,{useEffect,useState} from 'react'
import { popupManager } from '../common/PopupManager';
import { claimShareLending, claimShareLp, convertEthToUSD2, viewShareLending, viewShareLp } from '../../functions/lendingfunctions';
import { getPairAddressForBondedTokenForGraph } from '../../functions/factoryFunctions';

export default function RewardsPopup({signer,handleHideRewards,validateChainId}) {
      const [lpRewards, setlpRewards] = useState(0)
      const [protocolRewards, setprotocolRewards] = useState(0)
    
    useEffect(() => {
        if (!signer) return;    
        (async () => {
          try {
            const shareLP = await viewShareLp(signer)
            setlpRewards(await convertEthToUSD2(shareLP))
            const protocolTotal = await viewShareLending(signer);
            setprotocolRewards(await convertEthToUSD2(protocolTotal))
          } catch (err) {
            console.error("Error checking network:", err);
          }
        })();
      }, [signer]);

      const handleClaimBorrowRewards = async () => {
        let id = Date.now();

        try{
            const validateChain = await validateChainId(signer)
            popupManager.addPopup({
              id: id,
              type: "message",
              message: `Claiming LP Rewards`,
            });
          const usdcAddress = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'; // Example USDC address
          const usdtAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7'; // Example USDT address
          const stableCoinAddress = Math.random() < 0.5 ? usdcAddress : usdtAddress;
          const pairAddress = await getPairAddressForBondedTokenForGraph(
            stableCoinAddress,
            "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
            'ethereum'
          );
          const response = await claimShareLp(pairAddress,signer)
          popupManager.removePopup(id);
                let successful_id = Date.now();
                popupManager.addPopup({
                  id: successful_id,
                  type: "success",
                  message:
                    "Transaction sent!",
            });

        }catch(e){
            popupManager.removePopup(id);
                  popupManager.addPopup({
                    id: Date.now(),
                    type: "error",
                    message: e.toString(),
                    duration: 6000,
                  });
          console.log(e)
        }
      }
      const handleClaimLendingRewards = async () => {
        let id = Date.now();

        try{
            const validateChain = await validateChainId(signer)
            popupManager.addPopup({
              id: id,
              type: "message",
              message: `Claiming LP Rewards`,
            });
          const usdcAddress = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'; // Example USDC address
          const usdtAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7'; // Example USDT address
          const stableCoinAddress = Math.random() < 0.5 ? usdcAddress : usdtAddress;
          const pairAddress = await getPairAddressForBondedTokenForGraph(
            stableCoinAddress,
            "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
            'ethereum'
          );
          const response = await claimShareLending(pairAddress,signer)
          popupManager.removePopup(id);
                let successful_id = Date.now();
                popupManager.addPopup({
                  id: successful_id,
                  type: "success",
                  message:
                    "Transaction sent!",
            });
          console.log(response)
        }catch(e){
            popupManager.removePopup(id);
                  popupManager.addPopup({
                    id: Date.now(),
                    type: "error",
                    message: e.toString(),
                    duration: 6000,
                  });
          console.log(e)
        }
      }
  return (
    <div
          className="
            fixed inset-0 
            bg-black/40 
            backdrop-blur-sm 
            flex 
            items-center 
            justify-center 
            z-50
          "
        >
          <div
            className="
              bg-[#0e1018]
              border 
              border-gray-700
              text-white
              max-w-sm 
              w-full 
              mx-2 
              p-6 
              rounded-lg 
              shadow-lg
            "
          >
            {/* Modal Header */}
            <div className="flex justify-between items-center mb-6">
              <div className='flex items-center gap-2'>
                <h3 className="text-xl font-semibold text-white">
                    Eulend Rewards
                </h3>
                
              </div>

              <button
                onClick={handleHideRewards}
                className="
                  text-white
                  transition-colors 
                  text-xl mb-[2px]
                "
              >
                &times;
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex flex-col space-y-4">
              <label className=' flex justify-between w-full'>
                <p className="text-sm text-white text-start w-full">
                Protocol Rewards
                </p>
                <p className='text-start text-sm text-gray-300'>${protocolRewards && protocolRewards === 0 ? "-": protocolRewards}</p>
                
              </label>
              <label className=' text-start text-sm  text-gray-500 border-b border-white/10 pb-3'>
              Rewards generated by lending pools for lenders
              </label>
              <button
                className={`bg-green-400/10  hover:bg-green-400/15 border text-[13px] font-semibold 
                    border-green-400/40 hover:border-green-400/50  rounded-md ease-in duration-100 
                    text-gray-300 hover:text-gray-100  py-[10px]  w-full mx-0 mb-16
                    `}
                onClick={() => handleClaimLendingRewards()}
                >
                Claim
                </button>
              <label className=' flex justify-between w-full pt-4 '>
                <p className="text-sm text-white text-start w-full">
                LP Fees Rewards
                </p>
                <p className='text-start text-sm text-gray-300'>${lpRewards && lpRewards === 0 ? "-": lpRewards}</p>
              </label>
              <label className=' text-start text-sm  text-gray-500 border-b border-white/10 pb-3'>
              Rewards generated by closed borrows
              </label>
              <button
                className={`bg-green-400/10  hover:bg-green-400/15 border text-[13px] font-semibold 
                    border-green-400/40 hover:border-green-400/50 rounded-md ease-in duration-100 
                    text-gray-300 hover:text-gray-100  py-[12px]  w-full mx-0
                    `}
                onClick={() => handleClaimBorrowRewards()}
                >
                Claim
                </button>
              
            </div>
          </div>
        </div>
          )
}
